import { render } from "./RandomQuoteButton.vue?vue&type=template&id=34b46f94&scoped=true&ts=true"
import script from "./RandomQuoteButton.vue?vue&type=script&lang=ts"
export * from "./RandomQuoteButton.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b46f94"]])

export default __exports__